{
  "title": "Panel",
  "description": "Resumen del rendimiento y analítica de su negocio o institución",
  "descriptionSelect": "Seleccione un negocio o institución para ver la analítica",
  "descriptionGetStarted": "Comience creando su primer negocio o institución",
  "greetingMorning": "Buenos días",
  "greetingAfternoon": "Buenas tardes",
  "greetingEvening": "Buenas noches",
  "welcomeSubtitle": "Esto es lo que está ocurriendo hoy con su negocio o institución.",
  "emptyNoBusinessTitle": "Aún no hay negocio o institución",
  "emptyNoBusinessDescription": "Cree su primer negocio o institución para comenzar a gestionar sus servicios, citas y más.",
  "emptyNoBusinessCta": "Crear su primer negocio o institución",
  "emptyNoBusinessHint": "Puede crear varios negocios o instituciones y cambiar entre ellos en cualquier momento.",
  "emptyNotSelectedTitle": "Ningún negocio o institución seleccionado",
  "emptyNotSelectedDescription": "Seleccione un negocio o institución en la barra lateral para ver su analítica y rendimiento.",
  "loadError": "Error al cargar los datos del panel.",
  "tryAgain": "Intentar de nuevo",
  "chartBookings": "Gráfico de reservas no disponible",
  "chartFulfillment": "Gráfico de cumplimiento no disponible",
  "chartRevenue": "Gráfico de ingresos no disponible",
  "chartCustomerGrowth": "Gráfico de crecimiento de clientes no disponible",
  "chartAppointmentStatus": "Gráfico de estado de citas no disponible",
  "chartServicePerformance": "Gráfico de rendimiento de servicios no disponible",
  "chartPeakHours": "Gráfico de horas pico no disponible",
  "chartRatings": "Gráfico de calificaciones no disponible",
  "chartAppointmentsTable": "Tabla de citas no disponible",
  "starSingular": "Estrella",
  "starPlural": "Estrellas",
  "charts": {
    "timeRange": {
      "placeholder": "Seleccionar rango",
      "daily": "Diario",
      "monthly": "Mensual",
      "yearly": "Anual"
    },
    "trend": {
      "up": "Tendencia al alza del {{percent}}% este mes",
      "down": "Tendencia a la baja del {{percent}}% este mes"
    },
    "ranges": {
      "last10Days": "Últimos 10 días",
      "last6Months": "Últimos 6 meses"
    },
    "bookings": {
      "title": "Total de reservas",
      "description": "Reservas completadas en los últimos 10 días",
      "metricLabel": "Reservas"
    },
    "revenue": {
      "title": "Ingresos",
      "description": "Ingresos totales generados en los últimos 6 meses",
      "metricLabel": "Ingresos",
      "totalPrefix": "Total: GH₵{{total}}",
      "rangeWithTotal": "{{range}} • Total: GH₵{{total}}"
    },
    "fulfillment": {
      "title": "Tasa de cumplimiento de servicios",
      "description": "Porcentaje de servicios completados",
      "fulfilledLabel": "Cumplidos",
      "target": "Objetivo",
      "current": "Actual"
    },
    "customerGrowth": {
      "title": "Crecimiento de clientes",
      "description": "Clientes nuevos y recurrentes en los últimos 6 meses",
      "labels": {
        "new": "Clientes nuevos",
        "returning": "Clientes recurrentes"
      },
      "summary": "{{range}} • Nuevos: {{new}} • Recurrentes: {{returning}}"
    },
    "customerSatisfaction": {
      "title": "Satisfacción del cliente",
      "description": "Distribución de calificaciones de reseñas de clientes",
      "metricLabel": "Reseñas",
      "averageRating": "Calificación promedio: {{rating}}/5",
      "fromReviews": "de {{count}} reseñas",
      "averageRatingFromReviews": "Calificación promedio: {{rating}}/5 de {{count}} reseñas",
      "ratingLabel": "{{count}} {{starLabel}}"
    },
    "appointmentStatus": {
      "title": "Estado de citas",
      "description": "Distribución de citas por estado",
      "total": "Total de citas: {{total}}",
      "statuses": {
        "COMPLETED": "Completada",
        "PENDING": "Pendiente",
        "CANCELLED": "Cancelada",
        "RESCHEDULED": "Reprogramada",
        "ACTIVE": "Activa"
      }
    },
    "peakHours": {
      "title": "Horas pico",
      "description": "Distribución de reservas a lo largo del día",
      "metricLabel": "Reservas",
      "peakBookingTime": "Hora pico de reservas:"
    },
    "servicePerformance": {
      "title": "Rendimiento de servicios",
      "description": "Reservas e ingresos por tipo de servicio",
      "labels": {
        "bookings": "Reservas",
        "revenue": "Ingresos"
      },
      "topService": "Servicio principal: {{service}}",
      "noServices": "Sin servicios"
    },
    "appointmentsTable": {
      "title": "Próximas citas",
      "description": "Próximas citas programadas a partir de hoy (UTC)",
      "fallbacks": {
        "customer": "Cliente",
        "service": "Servicio",
        "time": "--"
      },
      "columns": {
        "customer": "Cliente",
        "name": "Nombre",
        "service": "Servicio",
        "dateTime": "Fecha y hora"
      },
      "empty": {
        "title": "Sin citas próximas",
        "descriptionWithBusiness": "No hay citas programadas a partir de hoy para este negocio ({{businessId}}). Si espera alguna, confirme que pertenece a este negocio en la página de Citas.",
        "descriptionWithoutBusiness": "No hay citas programadas a partir de hoy para el negocio seleccionado."
      }
    }
  },
  "quickActions": {
    "title": "Acciones rápidas",
    "addProvider": "Agregar proveedor",
    "newService": "Nuevo servicio",
    "appointments": "Citas",
    "income": "Ingresos"
  },
  "kpi": {
    "totalBookings": "Total de reservas",
    "totalBookingsDescription": "Reservas de todos los tiempos",
    "totalRevenue": "Ingresos totales",
    "totalRevenueDescription": "Ganancias totales",
    "totalCustomers": "Total de clientes",
    "totalCustomersDescription": "Clientes activos",
    "averageRating": "Calificación promedio",
    "averageRatingDescription": "Satisfacción del cliente",
    "notAvailable": "N/D",
    "changeFromLastPeriod": "{{percent}}% respecto al período anterior"
  },
  "onboarding": {
    "title": "Prepare su negocio",
    "progress": "{{completed}} de {{total}} pasos completados",
    "dismiss": "Descartar lista de verificación",
    "pendingApproval": "Su negocio está pendiente de aprobación. La mayoría de los pasos de configuración se desbloquean cuando un administrador verifica su perfil.",
    "continue": "Continuar: {{step}}",
    "steps": {
      "approved": {
        "title": "Negocio aprobado",
        "descriptionApproved": "Su negocio está verificado y listo para la configuración.",
        "descriptionPending": "Su negocio está en revisión. Puede preparar proveedores y servicios una vez aprobado.",
        "descriptionRejected": "Su negocio no fue aprobado. Contacte soporte o actualice su perfil."
      },
      "providers": {
        "title": "Agregar un proveedor de servicio",
        "description": "Los proveedores prestan sus servicios y se asignan a unidades."
      },
      "services": {
        "title": "Crear un servicio",
        "description": "Defina lo que los clientes pueden reservar: nombre, precio e imagen."
      },
      "units": {
        "title": "Configurar unidades y disponibilidad",
        "description": "Agregue unidades de servicio con proveedores y franjas horarias semanales."
      },
      "activate": {
        "title": "Activar para clientes",
        "description": "Haga visible su servicio en la aplicación de clientes."
      }
    }
  }
}
